module.exports = __webpack_public_path__ + "static/media/reuse.360ee45f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reuse.svg
// module id = ./src/assets/images/reuse.svg
// module chunks = 0